import { FunctionComponent } from 'react'
import { CuiMealActions } from 'front-lib'
import { AddToCartButtonProps } from './AddToCartButton.types'
import { useMealActions } from 'src/hooks/coreUx/useMealActions'

export const AddToCartButton: FunctionComponent<AddToCartButtonProps> = ({
  attributes,
  product,
  index
}) => {
  const mealActionsProps = useMealActions(
    product,
    attributes.actions.onAdd,
    attributes.actions.onRemove
  )

  const quantity = mealActionsProps?.quantity || 0

  // UX ask to to hide it, since it doesnt fit the new design
  const strikethroughPrice =
    quantity > 0 ? null : mealActionsProps.strikethroughPrice

  return (
    <CuiMealActions
      {...mealActionsProps}
      isEditable={true}
      index={index}
      strikethroughPrice={strikethroughPrice}
    />
  )
}
